import { ApplicationExceptionHandler, errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { IdProofsService } from './id-proofs.service';
import { IdProofTypesDTO } from './dto/id-proof-types.dto';
import { IdProofsTypeResponseModel, AllIdProofTypesResponseModel } from '@gtpl/shared-models/masters';
import { IdProofTypeRequest } from './dto/id-proof-types.request';

@ApiTags('id-proofs')
@Controller('id-proofs')
export class IdProofsController {
    constructor(
        private idProofsService: IdProofsService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

      ){}
   /**
     * creates or updates a value of id Proof type
     * @param idProofTypesDTO IdProofTypesDTO
     * @returns IdProofsTypeResponseModel
     */
    @Post('/createIdProof')
    async createIdProof(@Body() idProofTypesDTO:IdProofTypesDTO,isUpdate:boolean=false,@Req() request:Request): Promise<IdProofsTypeResponseModel> {
        try {
            return await this.idProofsService.createIdProof(idProofTypesDTO, false,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(IdProofsTypeResponseModel, error)
        }
    }

    /**
     * creates or updates a value of id Proof type
     * @param idProofTypesDTO IdProofTypesDTO
     * @returns IdProofsTypeResponseModel
     */
    @Post('/updateIdProof')
    async updateIdProof(@Body() idProofTypesDTO: IdProofTypesDTO,@Req() request:Request): Promise<IdProofsTypeResponseModel> {
        try {
        return await this.idProofsService.createIdProof(idProofTypesDTO, true,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(IdProofsTypeResponseModel, error)
        }
    }

      /**
     * gets all the Value of getAllIdProofs
     * @returns AllIdProofTypesResponseModel
     */
    @Post('/getAllIdProofs')
    async getAllIdProofs(@Req() request: IdProofTypeRequest): Promise<AllIdProofTypesResponseModel> {
        try {
        return await this.idProofsService.getAllIdProofs();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllIdProofTypesResponseModel, error)
        }
    }

     /**
     * Activate Or De-Activate Value IdProofType
     * @param idProofTypeReq IdProofTypeRequest 
     * @returns Value IdProofsTypeResponseModel
     */
    @Post('/activateorDeactivateIdProof')
    async activateorDeactivateIdProof(@Body() idProofTypeReq: IdProofTypeRequest): Promise<IdProofsTypeResponseModel> {
        try {
            return await this.idProofsService.activateorDeactivateIdProof(idProofTypeReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(IdProofsTypeResponseModel, err);
        }
    }
}
